import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getUserActivePaymentMethod } from 'store/auth';

import { Highlight, Info } from 'components/Common';

export const ActivePaymentMethod = ({ t, activePaymentMethod }) => (
  <div className="row">
    <div className="column small-12 large-8">
      <Highlight>
        <Info>
          <Info.Title>
            {t('paymentMethod.active.activePaymentMethod')}
          </Info.Title>

          <Info.Content>
            {activePaymentMethod
              ? t('paymentMethod.active.paymentMethods.paymentCard', {
                  last4: activePaymentMethod.last4
                })
              : t('general.none')}
          </Info.Content>
        </Info>

        <Info>
          <Info.Title>{t('paymentMethod.active.nextPaymentDue')}</Info.Title>
          <Info.Content>12.11.2017</Info.Content>
        </Info>

        <Info>
          <Info.Title>{t('paymentMethod.active.totalAmount')}</Info.Title>
          <Info.Content>147,00 €</Info.Content>
        </Info>
      </Highlight>

      <Link
        className="button button--margin-bottom"
        to="/payment-method/update/payment-card"
      >
        {t('paymentMethod.updatePaymentMethod')}
      </Link>
    </div>
  </div>
);

ActivePaymentMethod.propTypes = {
  t: PropTypes.func.isRequired,
  activePaymentMethod: PropTypes.object
};

ActivePaymentMethod.defaultProps = {
  activePaymentMethod: null
};

const mapStateToProps = state => ({
  activePaymentMethod: getUserActivePaymentMethod(state)
});

export default connect(mapStateToProps)(translate()(ActivePaymentMethod));



// WEBPACK FOOTER //
// ./src/containers/ActivePaymentMethod/ActivePaymentMethod.js